import classNames from 'classnames';
import styles from './PersonaForm.module.css';
import useTitlePersona from './useTitlePersona';
import type {
  CommonFormProps,
  PersonaTitleFormErrors,
  BaseStateProps,
  MobxProps,
} from './useCommonState';
import buildInput from './Input';
import Control from './Control';
import { DotsIndicator } from 'common/components';
import UserSettingsAndAccessForm from 'admin/pages/Users/User/UserSettingsAndAccessForm';
import type { PermissionMap, UserSettings } from 'admin/types';

export default function TitleBasedForm(
  props: BaseStateProps & Omit<MobxProps, 'findSCIMGroups'> & CommonFormProps
) {
  const {
    canRevert,
    errors,
    loading,
    onSave,
    revertChanges,
    schema,
    setUserPermissions,
    setUserSettings,
    userPermissions,
    userSettings,
  } = useTitlePersona(props);
  if (loading) {
    return (
      <div className={classNames(styles.loadingHolder)}>
        <DotsIndicator color="#0e0d0d" size={12} marginTop={30} marginRight={5} />
      </div>
    );
  }
  return (
    <form className={classNames(styles.personaForm)} onSubmit={onSave}>
      <div className={classNames(styles.personaHeader)}>
        {props.selectedPersona
          ? `${props.editMode ? 'Edit ' : ''}${props.selectedPersona.name}`
          : 'Create New Persona'}
      </div>
      {schema.map((inputProps) => {
        if (inputProps.skip) return null;
        const input = buildInput(inputProps);
        return (
          <div key={inputProps.optionName} className={classNames(styles.personaRoot)}>
            {input}
            {errors[inputProps.optionName as keyof PersonaTitleFormErrors]?.[0] && (
              <div className={classNames(styles.errorLabel)}>
                {errors[inputProps.optionName as keyof PersonaTitleFormErrors]?.[0]}
              </div>
            )}
          </div>
        );
      })}

      <UserSettingsAndAccessForm
        disableAll={!props.editMode}
        isPersonaForm={true}
        userPermissions={(userPermissions || {}) as PermissionMap}
        setUserPermissions={setUserPermissions}
        setUserSettings={setUserSettings}
        userSettings={(userSettings || {}) as UserSettings}
      />
      <Control
        editMode={props.editMode}
        canRevert={canRevert}
        revertChanges={revertChanges}
        type="title"
        setEditMode={props.setEditMode}
        setPersonaFormState={props.setPersonaFormState}
      />
    </form>
  );
}
